export default __webpack_public_path__ + "static/media/learn-card-3.d46d3178.png";